(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("examResource", ["$resource", examResource]);
    function examResource($resource) {
        return $resource("/api/exams/:number/:action/:id/:localizationId", { number: "@number" }, {
            update: {
                method: "PUT"
            },
            getByNumber: {
                method: "GET"
            },
            getManageExamsViewModel: {
                method: "GET",
                params: { action: "manageExamsViewModel" }
            },
            getExamSelectionModalExamsViewModal: {
                method: "GET",
                params: { action: "examSelectionModalExamsViewModal", localizationId: "@localizationId" }
            },
            getManageExamCategoriesViewModel: {
                method: "GET",
                params: { action: "manageExamCategoriesViewModel" }
            },
            getExamCategoryViewModel: {
                method: "GET",
                params: { action: "examCategoryViewModel" }
            },
            reorderExamCategories: {
                method: "POST",
                params: { action: "reorderExamCategories" }
            },
            postExamCategoryCreate: {
                method: "POST",
                params: { action: "categories" }
            },
            getExamPrintJobsViewModel: {
                method: "GET",
                params: { action: "examPrintJobsViewModel" }
            },
            createExamPrintJob: {
                method: "POST",
                params: { action: "examPrintJobs" }
            },
            getExamPrintJobViewModel: {
                method: "GET",
                params: { action: "examPrintJobViewModel" }
            },
            deleteExamPrintJob: {
                method: "DELETE",
                params: { action: "examPrintJobs" }
            }
        });
    }
}());
